





































































































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class NoticeModal extends Vue {
  @Prop() private title!: string
  @Prop() private message!: string

  private closeModal () {
    this.$emit('close-modal')
  }
}
